import { cn } from 'src/shared/lib/utils';

interface DescriptionProps {
  text: string;
  className?: string;
}

export default function Description({ text, className }: DescriptionProps) {
  return <span className={cn('text-typography-grey text-sm', className)}>{text}</span>;
}
